import { useLocation } from "react-router";

import styles from "@components/account/AccountDropdown.module.css";
import Icon from "@components/text/Icon";
import InternalLink from "@components/typography/InternalLink";
import useMyClient from "@hooks/useMyClient";
import { journeyRoute } from "@utils/routeUtils";

type Props = {
  journeyId: string;
};

const AccountDropdown = ({ journeyId }: Props) => {
  const myClient = useMyClient();

  const location = useLocation();
  const path = journeyRoute({ journeyId, linkAfterJourney: "/account", myClient });
  const isCurrent = location.pathname.split("?")[0] === path.split("?")[0];

  return (
    <InternalLink
      aria-current={isCurrent ? "page" : undefined}
      data-test="account-button"
      expand
      linkEventCreateVariables={{ journeyId }}
      stylized={false}
      to={path}
    >
      <div className={styles.button}>
        <Icon color="primary" icon="gear" />
      </div>
    </InternalLink>
  );
};

export default AccountDropdown;
